import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { Observable, take } from 'rxjs'
import { ICustomProduct } from '../../../../models/interface/product.interface'
import { ProductDetailsService } from '../../../../services/product.service'
import { UserPermissionService } from '../../../../services/user-permission/user-permission.service'
import { CustomProductReplacementService } from '../../custom-product-replacement/custom-product-replacement.service'

@Component({
    selector: 'app-custom-product-list-item',
    templateUrl: './custom-product-list-item.component.html',
    styleUrls: ['./custom-product-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomProductListItemComponent implements OnInit {
  @Input() product: ICustomProduct
  @Input() compare? = true
  public isLoggedIn$: Observable<boolean>
  public isProductDiscontinuedInRegion: boolean = false

  constructor(
    private authService: AuthService,
    public userPermissionService: UserPermissionService,
    private productService: ProductDetailsService,
    private cdr: ChangeDetectorRef,
    private customProductReplacementService: CustomProductReplacementService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isUserLoggedIn()
    this.productService
      .getReplacementProduct(this.product.code)
      .pipe(take(1))
      .subscribe((result) => {
        this.product = {
          ...this.product,
          ...result
        }

        this.isProductDiscontinuedInRegion = this.customProductReplacementService.isDiscontinuedRegion(this.product)
        this.cdr.detectChanges()
      })
  }
}
